/*
    Create by BaiZhiming 2015-12-26
*/
"use strict";
angular.module("copyUrlModule", ["ngClipboard"])
    .config(['ngClipProvider', function(ngClipProvider) {
        ngClipProvider.setPath("./lib/zeroclipboard/ZeroClipboard.swf");
    }])
    .controller("copyUrlCtrl", ["$scope", "$modalInstance", "copyParams", "modalDialog", function($scope, $modalInstance, copyParams, modalDialog) {
        $scope.url = copyParams.url;
        $scope.copyUrl = function() {
            window.getSelection().removeAllRanges();
            var newElem = document.querySelector('.toBeCompiled-review-container .body');
            var range = document.createRange();
            range.selectNode(newElem);
            window.getSelection().addRange(range);
            var successful = document.execCommand('copy');
            window.getSelection().removeAllRanges();
            if ("successful") {
                modalDialog.alertType("复制成功", "", "success", false, function() {
                    $modalInstance.dismiss();
                });
            }
        };
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]);